import { eventTracker } from 'app/modules/Segment';
import {
  buildJusfyEventsContext,
  buildJusfyEventsProperties,
} from 'app/modules/Segment/buildJusfyEvent';
import { FeatureEnum, TContext, TProperties } from 'app/modules/Segment/types';

export const EVENTS = {
  MODAL_VIEWED: 'oab_partnership_modal_viewed',
  VERIFICATION_SUBMITTED: 'oab_partnership_verification_submitted',
  RESULT_VIEWED: 'oab_partnership_result_viewed',
  NOT_FOUND_CORRECTION_ATTEMPTED: 'oab_partnership_not_found_correction_attempted',
  CONTINUED_WITHOUT_COUPON: 'oab_partnership_continued_without_coupon',
} as const;

function buildBaseProperties(
  event: string,
  eventMeaning: string,
  relevantUserActivity: boolean,
  extraProperties: Partial<TProperties> = {},
): TProperties {
  return buildJusfyEventsProperties({
    event,
    feature: FeatureEnum.CHECKOUT,
    eventMeaning,
    relevantUserActivity,
    extraProperties,
  });
}

export function trackOabPartnershipModalViewed(): void {
  const event = EVENTS.MODAL_VIEWED;
  const context: TContext = buildJusfyEventsContext({ component: 'modal-component' });

  eventTracker.track({
    event,
    properties: buildBaseProperties(
      event,
      'Disparado quando o modal de verificação da parceria CAA-PR é exibido, ao abrir o cadastro com um dos dois cupons de faixa especial.',
      false,
    ),
    context,
  });
}

export function trackOabPartnershipVerificationSubmitted(): void {
  const event = EVENTS.VERIFICATION_SUBMITTED;
  const context: TContext = buildJusfyEventsContext({ component: 'button-component' });

  eventTracker.track({
    event,
    properties: buildBaseProperties(
      event,
      'Disparado ao confirmar a verificação de OAB no modal da parceria CAA-PR.',
      true,
    ),
    context,
  });
}

export function trackOabPartnershipResultViewed(
  outcome: 'eligible' | 'range_mismatch' | 'no_special_plan' | 'not_found' | 'verify_unavailable',
): void {
  const event = EVENTS.RESULT_VIEWED;
  const context: TContext = buildJusfyEventsContext({ component: 'modal-component' });

  eventTracker.track({
    event,
    properties: buildBaseProperties(
      event,
      'Disparado quando o modal da parceria CAA-PR mostra o resultado da verificação de OAB.',
      false,
      { outcome },
    ),
    context,
  });
}

export function trackOabPartnershipNotFoundCorrectionAttempted(): void {
  const event = EVENTS.NOT_FOUND_CORRECTION_ATTEMPTED;
  const context: TContext = buildJusfyEventsContext({ component: 'button-component' });

  eventTracker.track({
    event,
    properties: buildBaseProperties(
      event,
      'Disparado ao clicar em "Corrigir e verificar novamente" após o desfecho "não encontrado" no modal da parceria CAA-PR.',
      true,
    ),
    context,
  });
}

export function trackOabPartnershipContinuedWithoutCoupon(): void {
  const event = EVENTS.CONTINUED_WITHOUT_COUPON;
  const context: TContext = buildJusfyEventsContext({ component: 'button-component' });

  eventTracker.track({
    event,
    properties: buildBaseProperties(
      event,
      'Disparado ao clicar em "Continuar sem cupom" (desfecho "não encontrado" ou fechamento antecipado) no modal da parceria CAA-PR.',
      true,
    ),
    context,
  });
}
